const setupCentralPageentryVideo = () => {
	const pageentryVideo = document.getElementById(
		'pageentries-video' ) as HTMLVideoElement;
	const pageentryVideoPlayPauseButton = document.getElementById(
		'pageentries-slider--playpause' )?.firstElementChild as HTMLButtonElement;

	const pageentryVideoPlaySpan = pageentryVideoPlayPauseButton?.firstElementChild?.firstElementChild;
	const pageentryVideoPauseSpan = pageentryVideoPlayPauseButton?.firstElementChild?.lastElementChild;

	if ( !pageentryVideo || !pageentryVideoPlayPauseButton ) return;

	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	prefersReducedMotion
		? pageentryVideo.removeAttribute( 'loop' )
		: pageentryVideo.setAttribute( 'loop', 'true' );
	prefersReducedMotion
		? pageentryVideo.removeAttribute( 'autoplay' )
		: pageentryVideo.setAttribute( 'autoplay', 'true' );

	pageentryVideo.addEventListener( 'play', () => {
		pageentryVideoPlaySpan?.classList.remove( 'flex' );
		pageentryVideoPlaySpan?.classList.add( 'hidden' );

		pageentryVideoPauseSpan?.classList.remove( 'hidden' );
		pageentryVideoPauseSpan?.classList.add( 'flex' );
	} );

	pageentryVideo.addEventListener( 'pause', () => {
		pageentryVideoPlaySpan?.classList.remove( 'hidden' );
		pageentryVideoPlaySpan?.classList.add( 'flex' );

		pageentryVideoPauseSpan?.classList.remove( 'flex' );
		pageentryVideoPauseSpan?.classList.add( 'hidden' );
	}	);

	pageentryVideoPlayPauseButton.addEventListener( 'click', () => {
		if ( pageentryVideo.paused || pageentryVideo.ended ) {
			pageentryVideo.play();
		} else {
			pageentryVideo.pause();
		}
	} );

};

setupCentralPageentryVideo();
